import React from 'react';
import {
  Box, Button, Container, Typography,
} from '@mui/material';
import { DisplayStringTrans } from '@gamiphy/react-i18n';
import { useLoyaltyPageContext } from '../context';
import { useIsSmallScreen } from '../hooks';
import { StyledLink } from './StyledComponents';

const HeroSection: React.FC = () => {
  const isMobile = useIsSmallScreen();
  const {
    app,
    isRealUser,
    isDraftUser,
    isPreview,
    images: { heroSectionImage },
    colors: { heroSectionTextColor },
    texts: {
      heroSectionText,
      heroSectionButtonText,
    },
    isMobilePreview,
    onSignUp,
  } = useLoyaltyPageContext();

  const img = React.useMemo(() => {
    if (isMobile || isMobilePreview) {
      return heroSectionImage?.mobile?.url ?? heroSectionImage?.desktop?.url;
    }
    return heroSectionImage?.desktop?.url;
  }, [isMobilePreview, isMobile, heroSectionImage?.desktop?.url, heroSectionImage?.mobile?.url]);

  return (
    <Box pb={{
      xs: 3,
      sm: 5,
    }}
    >
      <Container disableGutters>
        <Box sx={{
          background: img && `linear-gradient(180deg, rgba(0, 0, 0, 0.01) 0%, rgba(0, 0, 0, 0.2) 100%), url(${img})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          textAlign: 'center',
          backgroundRepeat: 'no-repeat',
          py: isMobilePreview ? 5 : 15,
          width: '100%',
          maxHeight: 'fit-content',
          height: '100%',
        }}
        >
          <Box sx={{
            maxWidth: '60%',
            margin: '0 auto',
          }}
          >
            <Box mb={2} sx={{ mt: '4.3rem' }}>
              <Typography
                align="center"
                color={heroSectionTextColor}
                variant="subtitle2"
                sx={{
                  fontSize: {
                    xs: '1.3rem',
                    sm: '1.8rem',
                  },
                  lineHeight: {
                    xs: '3.5rem',
                    sm: '4.5rem',
                  },
                }}
              >
                {!isRealUser && <DisplayStringTrans displayString={heroSectionText} />}
              </Typography>
              <Typography variant="h1" color={heroSectionTextColor}>
                {app?.name}
              </Typography>
            </Box>
            {
              ((!isDraftUser && !isRealUser) || isPreview) && (
                <StyledLink target="_top" onClick={onSignUp}>
                  <Button
                    variant="contained"
                    sx={{
                      padding: '0.3rem 2rem',
                      borderRadius: '24px',
                      fontSize: '18px',
                      fontWeight: 500,
                      bgcolor: 'primary.main',
                      border: 'none',
                      textTransform: 'unset',
                    }}
                  >
                    <DisplayStringTrans displayString={heroSectionButtonText} />
                  </Button>
                </StyledLink>
              )
            }
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;
